import { useFCMRegistration } from '../hooks/useFCMRegistration'
import FCMListener from './FCMListener'

export const FCMRuntime = () => {
  useFCMRegistration()
  return <FCMListener />
}

export default FCMRuntime
